import React from "react";
import { useMutation } from "@apollo/client";
import { useController } from "react-hook-form";

import { FILE_UPLOAD } from "./mutations";

function UploadFile({ accept, name, control, required }) {
  const [mutation, { loading }] = useMutation(FILE_UPLOAD);
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
    rules: { required },
    defaultValue: {},
  });

  const handleChange = e => {
    const { files } = e.target;

    if (files.length) {
      const file = files[0];

      mutation({ variables: { file } })
        .then(response => {
          const { data } = response;

          onChange({ targetId: data.entity.fid, ...data });
        })
        .catch(error => {
          console.error(error);
        });
    }
  };

  const onRemove = () => {
    onChange(undefined);
  };

  return (
    <div>
      {value?.entity ? (
        <div className="flex justify-between items-center mt-2">
          <div className="inline-flex gap-1 items-center">
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 384 512"
              className="css-nyaqgu"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"></path>
            </svg>

            <a href={value.entity.url} target="_blank" rel="noreferrer">
              {value.entity.filename}
            </a>
          </div>

          <button
            type="button"
            className="text-sm font-semibold"
            onClick={onRemove}
          >
            Eliminar
          </button>
        </div>
      ) : (
        <input
          accept={accept}
          name={name}
          type="file"
          onChange={handleChange}
          disabled={loading}
          required={required}
        />
      )}
    </div>
  );
}

UploadFile.defaultProps = {
  required: false,
};

export default UploadFile;
